import { Icon } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../../common/components/DataTable/DataTable";
import ScrollWrapper from "../../../common/components/ScrollBar";
import { setLocal } from "../../../helpers/Local";
import {
  checkApointment,
  getClinicPending,
  getProcedureCallAttempt,
  getSingleProcedure,
  selectPatient,
  selectProcedure,
  setGlobalLoading,
  setProcedureData,
} from "../../../store/actions";

const filterSuggestion = (suggestions, userInput) => {
  if (!userInput) {
    return suggestions;
  }
  let filteredSuggestions = [];

  filteredSuggestions = suggestions.filter(
    (suggestion) =>
      suggestion.patient_name && suggestion.patient_name.split(" ").join("").toLowerCase().indexOf(userInput.split(" ").join("").toLowerCase()) > -1
  );

  return filteredSuggestions;
};

const PendingTable = ({ title, search, selectedType, handleSidebar, handleSelect }) => {
  const ref = useRef(null);
  const data = useSelector((state) => state.procedure.pending_clinics);
  const isConfirmed = useSelector((state) => state.procedure.isConfirmed);

  const dispatch = useDispatch();

  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (isConfirmed) {
      dispatch(setProcedureData("resource", null));
    }
  }, [isConfirmed]);

  useEffect(() => {
    dispatch(setProcedureData("loadingResource", true));
    dispatch(setProcedureData("loadingPending", true));
    dispatch(getClinicPending({}));
  }, []);

  const tableRows = useMemo(() => {
    if (data) {
      setOffset(0);
      return filterSuggestion(data, search);
    }
    return [];
  }, [data, search]);

  const rowData = useMemo(() => {
    if (!tableRows || !tableRows.length) {
      return [];
    }
    if (tableRows && tableRows.length && offset <= tableRows.length) {
      const count = Math.min(50, tableRows.length - offset);
      return tableRows.slice(0, offset + count);
    }
  }, [offset, tableRows]);

  const handleRow = async (index, id) => {
    dispatch(setGlobalLoading(true));
    dispatch(setProcedureData("loadingResource", true));
    dispatch(selectPatient(rowData[index]["patient_id"]));
    dispatch(selectProcedure(rowData[index]));
    dispatch(getSingleProcedure(rowData[index].id));
    setLocal("procedure_id", rowData[index].id);
    dispatch(getProcedureCallAttempt(rowData[index].id));
    dispatch(checkApointment(false));
    handleSelect("pending");
    dispatch(setGlobalLoading(false));
    handleSidebar();
  };

  const onScroll = (values) => {
    if (rowData && values.scrollTop > rowData.length * 50 && offset < tableRows.length) {
      const count = Math.min(50, tableRows.length - offset);
      setOffset(offset + count);
    }
  };

  const getProcedureName = (row) => {
    if (row.side) return row.side + " " + row.procedure_name;
    else return row.procedure_name;
  };

  return (
    <div ref={ref} className="tableContainer">
      <ScrollWrapper css="no-padding no-b-padding x-hidden" onScrollFrame={onScroll}>
        <div className="tableList">
          <DataTable
            isXHidden={true}
            tableWidth={"100%"}
            title="new_patient_pending"
            isNormal={true}
            labels={["Patient Name", "Clinic", "Appointment Date"]}
            widths={["30%", "40%", "30%"]}
            defaultActive={-1}
            disableDelete={true}
            columns={[
              { sortable: false, key: "name" },
              { sortable: false, key: "referral_condition" },
              { sortable: false, key: "referral_date" },
            ]}
            handleClickRow={(row, index) => {
              handleRow(index);
            }}
            rowData={(rowData || []).map((row, index) => {
              return {
                name: (
                  <div
                    className="iconField td with-icon"
                    style={{
                      display: "flex",
                      paddingLeft: "0.25rem",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Icon type="notification" theme="twoTone" twoToneColor="#0f62fe" />
                    <p
                      style={{
                        paddingLeft: "0.75rem",
                        textTransform: "capitalize",
                      }}
                    >
                      {row.patient && row.patient?.name.toLowerCase()}
                    </p>
                  </div>
                ),
                referral_condition: getProcedureName(row),
                referral_date: row.appointment_date && moment(row.appointment_date).format("MM/DD/YYYY hh:mm A"),
              };
            })}
          />
        </div>
      </ScrollWrapper>
    </div>
  );
};

export default PendingTable;
